import React from "react";
import "./PortfolioStory.scss";

import DrapmeMock from "../../assets/images/Drapme-mockups2.png";
import feature1 from "../../assets/images/Features-1.png";
import feature2 from "../../assets/images/Features-2.png";

const PortfolioStory = () => {
  return (
    <section className="section portfolioStory">
      <article className="portfolioStory__container container">
        <div className="portfolioStory__container--contents">
          <div className="contents__item">
            <h3>Problems</h3>
            <p>
              Drapme wanted to create a platform that offer a specific services
              for theirs client, and focus on a particular target audience,
              while connecting clients to various limo vendors registered under
              drapme as a vendor. It help other individuals or business who do
              not have the means to make use of their vehicle and taking it on
              the platform and connects them to various clients.
            </p>
          </div>

          <div className="contents__item">
            <h3>Challenges</h3>
            <p>
              Our Design challenges includes optimizing user flow for carpooling
              and connecting a chauffeur, ensuring payment security, maintaining
              consistency & compatibility across devices for a seamless user
              experience.
            </p>
          </div>

          <div className="contents__item">
            <h3>Our Solutions</h3>
            <p>
              Integration of a package option for client to choose various
              chauffeur service option based off their preferences and cost,
              minimizing the work process it takes a user to complete a flow or
              process. Also, We applied minimalist design, ensuring that the app
              provides an aesthetic and engaging experience.
            </p>
          </div>
        </div>

        <figure className="portfolioStory__container--image">
          <img src={DrapmeMock} width={1000} height={1000} alt="user Story" />
        </figure>

        <div className="portfolioStory__container--features">
          <figure className="feature-right">
            <img
              src={feature2}
              width={1000}
              height={1000}
              alt="user Story"
              quality={100}
            />
          </figure>
          <figure className="feature-left">
            <img
              src={feature1}
              width={1000}
              height={1000}
              alt="user Story"
              quality={100}
            />
          </figure>
        </div>
      </article>
    </section>
  );
};

export default PortfolioStory;
